/**
 * Functions for sending OAuth2 requests to the server.
 */

import { getAuth, signInWithEmailAndPassword, UserCredential, createUserWithEmailAndPassword } from 'firebase/auth'
import { db } from 'modules/database'
import { store } from 'modules/root'
import { downloadUser } from 'modules/user/actions'
import { deleteUndefined } from 'modules/database/migration'
import { doc, setDoc } from 'firebase/firestore'

/** Attempt to obtain an AccessToken with the given credentials. */
export async function authenticate(username: string, password: string): Promise<UserCredential> {
	console.log(`AUTH: authenticate: ${username}`)
	
	const auth = getAuth()
	try {
		console.log('AUTH: signing in')
		const userCredential = await signInWithEmailAndPassword(auth, username, password)
		console.log(`AUTH: authenticated: ${JSON.stringify(userCredential)}`)
		return userCredential
	} catch (error) {
		console.error(`AUTH: ${error instanceof Error ? error.message : error}`)
		throw error
	}
}

export interface RegistrationForm {
	emailAddress: string
	password: string
	givenName?: string
	familyName?: string
	organisation?: string
	country?: string
}

export async function register(form: RegistrationForm): Promise<UserCredential> {
	console.log('AUTH: register')
	try {
		const userCredential = await createUserWithEmailAndPassword(getAuth(), form.emailAddress, form.password)
		console.log('register', userCredential)
		if (userCredential.user) {
			const data = {
				givenName: form.givenName,
				familyName: form.familyName,
				organisation: form.organisation,
				country: form.country,
				terms: new Date().toUTCString(), /* The time at which they accepted the terms */
			}
			deleteUndefined(data)
			await setDoc(doc(db, 'users', userCredential.user.uid), data)

			/* We downloaded the user as soon as the user was logged in, so we need to download again now that we've updated the user */
			store.dispatch(downloadUser())
		}
		return userCredential
	} catch (error) {
		console.error(`AUTH: ${(error as Error).message}`)
		throw error
	}
}

export function logOut(): Promise<void> {
	console.log('AUTH: logOut')
	return getAuth().signOut()
}

/** Attempt to refresh the AccessToken using the given refresh token.
 * Returns a new AccessToken.
 */
// export function refresh(refreshToken: string): Promise<firebase.auth.UserCredential> {
// const config = getAuthConfig()
// let query = {
// 	client_id: config.clientId,
// 	client_secret: config.clientSecret,
// 	grant_type: 'refresh_token',
// 	refresh_token: refreshToken,
// }
// let formData = url.format({ query }).substring(1)

// let options: RequestInit = {
// 	method: 'POST',
// 	body: formData,
// 	headers: {
// 		'content-type': 'application/x-www-form-urlencoded'
// 	}
// }
// 	return fetchAccessToken(options)
// }

/** Refresh the access token, apply it to the store, and return a promise
 * indicating whether or not it was successful. This methods gets the current
 * refresh token from the store, so there's no need to know any context to
 * call it.
 */
// export function refreshTokenAndApply(): Promise<AccessToken> {
// 	return new Promise((resolve, reject) => {
// 		let accessToken = store.getState().auth.accessToken
// 		if (accessToken) {
// 			refresh(accessToken.refresh_token).then(refreshedAccessToken => {
// 				store.dispatch(actions.refreshedToken(refreshedAccessToken))
// 				resolve(refreshedAccessToken)
// 			}).catch(error => {
// 				store.dispatch(actions.refreshTokenFailed(Date.now()))
// 				reject(error)
// 			})
// 		} else {
// 			reject(new Error('Not logged in'))
// 		}
// 	})
// }
